import { ApiError } from '../../api/index.ts';
import type { CreateShopRequest, ShopType } from '../../api/types.ts';
import {
  deviceCountPayload,
  initialDeviceCountForm,
  validateDeviceCountForm,
  type DeviceCountFormState,
} from './deviceCountHelpers.ts';

const SHOP_CODE_MAX_LENGTH = 8;

export interface ShopCreateFormState extends DeviceCountFormState {
  shop_code: string;
  name: string;
  shop_type: ShopType;
  email: string;
  phone: string;
  address: string;
}

export const INITIAL_SHOP_CREATE_FORM: ShopCreateFormState = {
  shop_code: '',
  name: '',
  shop_type: 'live',
  email: '',
  phone: '',
  address: '',
  ...initialDeviceCountForm(),
};

/** Returns the first validation problem, or null when the form is submittable. */
export function validateShopCreateForm(form: ShopCreateFormState): string | null {
  const code = form.shop_code.trim();
  if (code === '') return 'Enter a shop code.';
  if (code.length > SHOP_CODE_MAX_LENGTH) return `Shop code must be ${SHOP_CODE_MAX_LENGTH} characters or fewer.`;
  if (form.name.trim() === '') return 'Enter a shop name.';
  return validateDeviceCountForm(form);
}

export function buildCreateShopPayload(form: ShopCreateFormState): CreateShopRequest {
  const payload: CreateShopRequest = {
    shop_code: form.shop_code.trim(),
    name: form.name.trim(),
    shop_type: form.shop_type,
    ...deviceCountPayload(form),
  };
  const email = form.email.trim();
  const phone = form.phone.trim();
  const address = form.address.trim();
  if (email !== '') payload.email = email;
  if (phone !== '') payload.phone = phone;
  if (address !== '') payload.address = address;
  return payload;
}

export function isShopCodeTaken(e: unknown): boolean {
  return e instanceof ApiError && e.code === 'shop_code_taken';
}

export function isShopNameTaken(e: unknown): boolean {
  return e instanceof ApiError && e.code === 'shop_name_taken';
}
